import React from "react"
import ResetPasswordForm from "../components/reset-password/ResetPasswordForm"
import { t } from "../i18n"

const ResetPasswordPage = (): JSX.Element => {
  return (
    <>
      <ResetPasswordForm/>
      <div className="u-mt-40">
        <a href="../session/new" className="Header-link Header-link--login jsLogin">
          <span className="Header-linkText">{t("v2020_pages.login")}</span>
        </a>
      </div>
    </>
  )
}

export default ResetPasswordPage
